import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { PageHeader, Collapse, List, Image } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { CaretRightOutlined } from "@ant-design/icons";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { packageDetailsSaga } from "./saga";
import * as selectors from "./selectors";
import Loader from "../../../../components/Loader";
const { Panel } = Collapse;

const PackageDetails = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: packageDetailsSaga });
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    dispatch(actions.fetchPackage({ id }));
  }, [dispatch, id]);

  const fetchedPackage = useSelector(selectors.selectPackage);
  const categoryData = useSelector(selectors.selectTestCategories);

  const handleBack = () => {
    history.goBack();
  };

  const renderTestCategories = (entries) => {
    const rows = [];

    Object.keys(entries).forEach((key, index) => {
      const entry = entries[key];
      const tests = entry.tests || {};
      // const selected = getSelectedTestsCount(entry._id);
      if (tests.length) {
        rows.push(
          <Panel
            header={
              <span style={{ fontWeight: "bold", color: "#0a8080" }}>
                {entry.name} ({tests.length} tests)
              </span>
            }
            key={index}
            style={{
              marginBottom: 20,
              overflow: "hidden",
              backgroundColor: "#eff3f7",
              border: "0px",
              borderRadius: 4,
              color: "#0a8080",
            }}
          >
            <div>
              <List
                itemLayout="horizontal"
                dataSource={tests}
                renderItem={(test) => (
                  <List.Item>
                    <List.Item.Meta title={test.parameter} />
                    <div> ₹ {test.price}</div>
                  </List.Item>
                )}
              />
            </div>
          </Panel>
        );
      }
    });
    return rows;
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader ghost={false} onBack={handleBack} title="Package Details" />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          padding: 24,
        }}
      >
        {fetchedPackage ? (
          <div>
            <h1>Package Name: {fetchedPackage?.name}</h1>
            <p>
              <strong>Status</strong>:{" "}
              {fetchedPackage?.isActive ? "Active" : "Deactivated"}
            </p>
            <p>
              <strong>Commodity</strong>:{" "}
              {fetchedPackage?.tests[0]?.test?.commodity?.name}
            </p>
            <p>
              <strong>Sample Variant</strong>: {fetchedPackage?.sampleVariant}
            </p>
            <p>
              <strong>Included Parameters</strong>
            </p>
            <div
              style={{
                background: "#fff",
                padding: "20px 20px 1px 20px",
                borderRadius: 4,
                marginBottom: 30,
              }}
            >
              <Collapse
                bordered={false}
                expandIconPosition="right"
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined
                    style={{ color: "#0a8080" }}
                    rotate={isActive ? 90 : 0}
                  />
                )}
                style={{ background: "#fff" }}
              >
                {renderTestCategories(categoryData)}
              </Collapse>
            </div>
            <p>
              <strong>Total Tests</strong>: {fetchedPackage?.tests?.length}
            </p>
            <p>
              <strong>Package Cost</strong>: ₹ {fetchedPackage?.cost}
            </p>

            {fetchedPackage?.image && (
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <strong>Package Image: </strong>
                <Image
                  src={fetchedPackage?.image}
                  alt="Package Image"
                  width={200}
                  height={200}
                  style={{
                    cursor: "pointer",
                    objectFit: "contain",
                  }}
                  preview={{
                    mask: "Click to view",
                  }}
                />
              </p>
            )}
          </div>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
};

export default PackageDetails;
